<div class="jsd-terms-use">
    <div class="jsd-terms-use_slogan">
        <h2>TERMO DE USO</h2>
        <h1>JAMES DELIVERY</h1>
    </div>

    <h3>TERMOS E CONDIÇÕES GERAIS DO “ENTREGADORES JAMES”</h3>

    <p>
        O aplicativo “Entregadores James” (ou “James”) é mantido e disponibilizado pela <b>COMPANHIA BRASILEIRA DE
        DISTRIBUIÇÃO</b> (“CBD”, ou “nós”, ou “GPA” – Grupo Pão de Açúcar), sociedade anônima de capital aberto, com
        sede na
        cidade de São Paulo, Estado de São Paulo, na Avenida Brigadeiro Luiz Antônio, nº 3.142, Bairro Jardim Paulista,
        CEP nº 01402-000, inscrita no Cadastro Nacional de Pessoas Jurídicas do Ministério da Economia (“CNPJ/ME”) sob o
        nº 47.508.4111/00001-56, com seus atos constitutivos arquivados na Junta Comercial de São Paulo sob NIRE
        35.3000.089.901, que incorporou sua antiga subsidiária integral, <b>JAMES INTERMEDIAÇÃO DE NEGÓCIOS LTDA</b>.
    </p>
    <p>
        Tendo em vista o nosso compromisso em buscar qualidade e segurança em todas
        as operações realizadas no Entregadores James, desenvolvemos cuidadosamente
        o presente Termo de Uso ("Termo") para que o Usuário tenha conhecimento
        das condições gerais de uso, bem como das regras a serem seguidas ao
        acessar e utilizar as funcionalidades do Entregadores James.
    </p>
    <p>
        Ao utilizar o Entregadores James, o Usuário concorda automaticamente com
        todas as regras e demais condições aqui estabelecidas, responsabilizando-se integralmente
        por todos e quaisquer atos praticados durante o uso do Entregadores
        James. Caso não concorde com as regras e condições estabelecidas, o Usuário
        deve se abster de utilizar o Entregadores James.
    </p>
    <h3>
        TERMOS DEFINIDOS
    </h3>
    <p>
        Os termos empregados no presente Termo deverão ser compreendidos conforme
        os conceitos a seguir:
    </p>
    <p>
        Conta: cadastro pessoal do Usuário na Plataforma.
    </p>
    <p>
        Usuário: pessoa cadastrada na Plataforma.
    </p>
    <p>
        Entregador: Usuário cadastrado na Plataforma, devidamente habilitado com
        CNH, e apto a prestar os Serviços de Delivery. Não é permitida a utilização de
        Permissão Provisória Para Dirigir.
    </p>
    <p>
        Informações Confidenciais: dados e informações pessoais de clientes, planos
        de marketing e negócio, vendas, informações financeiras, técnicas e operacionais
        do James, a que o Usuário tenha acesso pela plataforma.
    </p>
    <p>
        Plataforma: mecanismo de acesso. O aplicativo Entregadores James está disponível
        apenas para dispositivos móveis com sistema Android.
    </p>
    <p>
        Solicitação: pedido de contratação de Serviços de Delivery realizado pelo Cliente
        do GPA, por meio da Plataforma.
    </p>
    <p>
        Serviços de Delivery: operação de entrega de produtos contratada pelo Cliente
        do GPA e realizada pelo Entregador.
    </p>
    <p>
        Produtos: produtos ofertados pelo GPA aos seus Clientes, os quais são objeto
        dos Serviços de Delivery.
    </p>
    <p>
        Preço: valor total a ser cobrado do Cliente, no qual estão compreendidos a Taxa
        de Serviço, a Taxa do Entregador e o Valor do Pedido.
    </p>
    <p>
        Taxa do Entregador: valor destinado ao Entregador em virtude da realização
        dos Serviços de Delivery.
    </p>
    <p>
        Valor do Pedido: valor de aquisição dos Produtos, a ser pago pelo cliente do
        GPA.
    </p>
    <p>
        Veículo: meio de transporte utilizado pelo Entregador, para a realização dos
        Serviços de Delivery. Podendo ser bicicleta (inclusive elétrica), motocicleta,
        carros (independentemente do tamanho e/ou tipo, inclusive elétricos). Os veículos
        não especificados anteriormente são expressamente proibidos e não poderão
        ser utilizados pelo Entregador.
    </p>
    <article>
        <h3>1. OBJETO</h3>
        <p>
            1.1 O Entregadores James é uma modalidade de entrega de Produtos ofertados
            pelo GPA, que permite ao Cliente do GPA recebê-los de maneira prática e rápida
            em seu domicílio.
        </p>
    </article>
    <article>
        <h3>2. ACESSO À PLATAFORMA</h3>
        <p>
            2.1. O acesso à Plataforma é realizado por meio do aplicativo Entregadores James,
            disponível apenas para dispositivos móveis com sistemas Android.
        </p>
        <p>
            2.2. Ao acessar a Plataforma, o Usuário deve ler e manifestar a sua concordância
            ou discordância com as disposições contidas neste Termo, por meio do mecanismo
            de aceite ou recusa disponibilizado. Pelo aceite, o Usuário declara ciência
            e concordância expressa, sem quaisquer reservas, acerca do conteúdo do
            Termo. Caso o Usuário não concorde com os termos e condições estabelecidos,
            solicitamos que não continue o procedimento de registro no Entregadores James,
            e nos informe o(s) motivo(s) de sua discordância, se possível, para que
            possamos melhorar o conteúdo do Termo.
        </p>
    </article>
    <article>
        <h3>3. CADASTRO DE ENTREGADOR</h3>
        <p>
            3.1. O Entregador deve ter pelo menos 18 (dezoito) anos de idade, para realizar
            o cadastro de sua Conta na Plataforma. Contudo, para prestar Serviços de Delivery,
            conforme as condições em que os serviços serão prestados, a idade mínima
            será aquela prevista no Código de Trânsito Brasileiro ou em legislação
            específica que regulamente a atividade.
        </p>
        <p>
            3.1.1. Para prestar Serviços de Delivery com motocicleta ou motoneta, o Entregador
            deverá ter idade mínima de 21 (vinte e um) anos, possuir habilitação, por
            pelo menos 2 (dois) anos, na categoria “A”, e ser aprovado em curso especializado,
            nos termos da regulamentação do Contran.
        </p>
        <p>
            3.1.2. As bicicletas de propulsão humana e elétricas não se enquadram como
            motocicleta ou motoneta, de acordo com resolução do Contran, não se exigindo
            registro, licenciamento e habilitação, por parte do Entregador, que deverá ter a
            idade mínima de 18 (dezoito) anos para realizar os Serviços de Delivery com
            esses meios de transporte.
        </p>
        <p>
            3.1.3. Para prestar Serviços de Delivery com veículo motorizado, não abrangido
            pela categoria “A”, cujo peso bruto total não exceda a três mil e quinhentos
            quilogramas e cuja lotação não exceda a oito lugares, excluído o do motorista,
            o Entregador deverá possuir idade mínima de 18 (dezoito) anos e CNH na categoria
            “B”. Não é permitida a utilização de Permissão Provisória Para Dirigir.
        </p>
        <p>
            3.2. O Entregador é responsável por manter a sua Conta ativa, para ofertar os
            Serviços de Delivery. O Entregador que permanecer inativo por mais de 60
            (sessenta) dias terá a conta bloqueada automaticamente e a reativação estará
            condicionada à análise e aprovação do GPA.
        </p>
        <p>
            3.3. O Entregador não pode ter vínculo empregatício com nenhuma empresa do
            GPA. Identificado o cadastro de empregado de uma das empresas do GPA, a
            conta será bloqueada automaticamente na Plataforma.
        </p>
        <p>
            3.4. É permitido manter apenas uma Conta no Entregadores James. Caso seja
            detectado o registro de mais de uma Conta em nome do mesmo Usuário, ficará
            a critério do GPA excluir uma ou todas elas.
        </p>
        <p>
            3.5. Para a realização do cadastro como Entregador, deverão ser apresentadas
            as seguintes informações:
        </p>
        <ol class="ol-list-type-latin">
            <li>
                Informações Pessoais: nome, RG ou CNH, CPF, endereço, telefone, email,
                contato de emergência;
            </li>
            <li>
                Informações bancárias: conta corrente de titularidade do Entregador; e
            </li>
            <li>
                Documentos: cópia da CNH e dos documentos do Veículo a ser utilizado.
                Lembramos que não é permitida a utilização de Permissão Provisória
                Para Dirigir para prestar os Serviços de Delivery.
            </li>
        </ol>
        <p>
            3.6. Para confirmação da identidade e informações prestadas pelo Entregador
            na Plataforma, poderão ser solicitados dados adicionais e documentos comprobatórios,
            e utilizados mecanismos legais.
        </p>
        <p>
            3.7. Todas as Informações Pessoais fornecidas voluntariamente pelo Entregador,
            no momento do cadastro, serão protegidas em conformidade com a legislação
            vigente. Para saber mais sobre a forma como coletamos e processamos
            suas Informações Pessoais, solicitamos que acesse a nossa Política de Privacidade,
            disponibilizada em <a href="https://www.jamesdelivery.com.br/politica-de-privacidade">
            https://www.jamesdelivery.com.br/politica-de-privacidade</a>,
            com a qual o Entregador deverá estar de pleno acordo.
        </p>
        <p>
            3.8. O Entregador é o único responsável pela sua Conta e qualquer atividade
            relacionada. Por isso, não deve compartilhar seus dados de acesso (login e senha)
            com terceiros, ficando responsável por mantê-los em sigilo, bem como a
            comunicar imediatamente a perda, extravio ou furto dos dados de acesso. NÃO
            SEREMOS RESPONSÁVEIS POR ACESSOS REALIZADOS NA SUA
            CONTA ENTREGADORES JAMES COM O SEU LOGIN E SENHA POR
            TERCEIROS, BEM COMO POR QUALQUER DANO DIRETO OU INDIRETO
            RESULTANTE DO MAU USO OU DA INABILIDADE DO USO DO
            ENTREGADORES JAMES.
        </p>
        <p>
            3.9. Problemas de acesso da Conta deverão ser reportados imediatamente pelo
            Entregador ao GPA para as devidas providências, por meio do portal: <a
                href="https://app.pipefy.com/portals/31e619d9-e37e-48cf-83c0-75a7c8dbc75f">https://app.pipefy.com/portals/31e619d9-e37e-48cf-83c0-75a7c8dbc75f</a>.
        </p>
        <p>
            3.10. Ao Entregador é facultado solicitar a qualquer momento o cancelamento
            da sua Conta, por meio do portal: <a
                href="https://app.pipefy.com/portals/31e619d9-e37e-48cf-83c0-75a7c8dbc75f">https://app.pipefy.com/portals/31e619d9-
            e37e-48cf-83c0-75a7c8dbc75f</a>.
        </p>
        <h3>4. DOS SERVIÇOS DE DELIVERY</h3>
        <p>
            4.1. O Entregador receberá a Solicitação do Serviço de Delivery pelo aplicativo
            Entregadores James.
        </p>
        <p>
            4.2. Ao Entregador é permitido aceitar, recusar ou ignorar a Solicitação do Serviço
            de Delivery, sem nenhum ônus.
        </p>
        <p>
            4.3. O Entregador declara ter ciência de que deverá avaliar a distância da entrega
            e as condições de trânsito, considerando o Veículo utilizado por ele, inclusive,
            a fim de que a entrega seja realizada em tempo razoável.
        </p>
        <p>
            4.4. Ao aceitar a Solicitação, a Plataforma disponibilizará imediatamente ao
            Entregador as informações sobre o endereço da loja física, onde o Produto estará
            disponível para retirada, a modalidade da entrega e o endereço do Cliente
            para que proceda à entrega.
        </p>
        <p>
            4.5. O Entregador declara ter ciência de que, após aceitar a Solicitação e retirar
            o pedido, não será possível cancelá-la. A entrega deverá ser concluída imediatamente,
            não sendo permitido aguardar a próxima Solicitação ou acumular Solicitações
            para realizar as entregas nos respectivos endereços em única viagem.
            Tal prática não será tolerada, visto que gera atrasos e compromete o desempenho
            de toda a operação.
        </p>
        <p>
            4.5.1. A irregularidade dessa natureza poderá implicar a suspensão automática
            temporária do Entregador ou o cancelamento automático definitivo da sua permissão
            para prestar Serviços de Delivery.
        </p>
        <p>
            4.6. O Entregador declara estar ciente de que a entrega dos Produtos da modalidade
            Express deve ser obrigatoriamente realizada diretamente ao Cliente, inclusive
            em seu apartamento, se o caso. Portanto, os pedidos realizados nessa
            modalidade não podem ser entregues na portaria do prédio. Nas demais modalidades
            é permitida a entrega a terceiros e/ou na portaria do condomínio. O descumprimento
            dessa orientação poderá implicar a suspensão temporária do seu
            acesso na Plataforma.
        </p>
        <h3>5. RELACIONAMENTO DO ENTREGADOR COM O GPA</h3>
        <p>
            5.1. O Entregador declara estar ciente de que não há qualquer tipo de subordinação
            com o GPA, haja vista deter autonomia para determinar “quando” e “para
            quem” realizará os Serviços de Delivery.
        </p>
        <p>
            5.2. O Entregador também declara estar ciente de que o GPA poderá efetuar
            descontos na Taxa do Entregador, caso verifique a ocorrência de eventuais danos
            causados decorrentes dos Serviços de Delivery.
        </p>
        <p>
            5.3. O GPA não se responsabiliza por qualquer conduta incompatível do Entregador
            com os Serviços de Delivery, e de ações que prejudiquem o bom desempenho
            da operação do Entregados James, mediante dolo ou culpa, indireta ou
            diretamente. O Entregador será responsável por indenizar eventuais danos causados
            por ele decorrentes da prestação de Serviços de Delivery, inclusive, mas
            não se limitando, a avaria dos Produtos.
        </p>
        <p>
            5.4. O Entregador concorda que, havendo reincidência de casos de extravios,
            perdas, danos aos Produtos durante os Serviços de Delivery e de ações que prejudiquem
            o bom desempenho da operação do Entregadores James, mediante
            dolo ou culpa, indireta ou diretamente, o James poderá suspendê-lo automaticamente
            de maneira temporária ou cancelar em definitivo a sua permissão de
            utilizar a Plataforma.
        </p>
        <p>
            5.5. O Entregador deve agir com a devida cautela na execução dos Serviços de
            Delivery, sendo responsável por manter seguro de responsabilidade civil adequado
            para tanto, e observar as normas de segurança previstas no Código de
            Trânsito Brasileiro, inclusive as que dizem respeito às vestimentas e aos equipamentos
            de proteção para circulação nas vias.
        </p>
        <p>
            5.6. O Entregador declara ter ciência de que não é permitido conceder carona
            durante os Serviços de Delivery.
        </p>
        <p>
            5.5. O Entregador tem ciência de que, havendo reclamações formalizadas nos
            canais de atendimento GPA, elas serão devidamente apuradas. A constatação
            de qualquer irregularidade na conduta do Entregador poderá implicar a sua suspensão
            temporária automática ou o cancelamento definitivo automático da sua
            permissão de utilizar o Entregadores James, a depender da gravidade.
        </p>
        <p>
            5.6. As situações mencionadas no presente Termo que podem levar à suspensão
            temporária, ou ao cancelamento definitivo da sua permissão de utilizar a Plataforma,
            são meramente exemplificativas. Eventuais irregularidades não previstas
            neste Termo serão devidamente apuradas e aplicadas as medidas cabíveis,
            se o caso, respeitadas as previsões legais.
        </p>
        <p>
            5.7. A suspensão temporária mencionada neste Termo será de pelo menos 6
            (seis) meses, período em que a Conta do Entregador permanecerá inativa, resguardada
            a faculdade de o GPA avaliar caso a caso.
        </p>
        <h3>6. VEÍCULOS E EQUIPAMENTOS</h3>
        <p>
            6.1. O Entregador declara ter ciência de que não é responsabilidade do GPA
            fornecer o Veículo para a prestação dos Serviços de Delivery, de modo que as
            entregas deverão ser realizadas pelo Entregador por meio de Veículo próprio
            e/ou locado.
        </p>
        <p>
            6.2. O Entregador concorda que somente poderá utilizar o Veículo cadastrado
            na Plataforma para realizar a prestação dos Serviços de Delivery, resguardada
            a possibilidade de o Entregador substituir o Veículo cadastrado por outro, mediante
            sua solicitação e aprovação pelo GPA.
        </p>
        <p>
            6.1.1. Neste sentido, é de responsabilidade exclusiva do Entregador:
        </p>
        <ol class="ol-list-type-decimal">
            <li><p>
                realizar a manutenção do Veículo que utilizará para os Serviços de Delivery,
                mantendo-o em condições adequadas para tais fins;
            </p></li>
            <li><p>
                possuir e manter a CNH válida (não é permitida a Permissão Provisória
                para Dirigir), em caso de utilização de Veículos os quais necessitem de
                licença própria para direção;
            </p></li>
            <li><p>
                arcar com os custos e despesas relacionadas ao combustível do Veículo,
                e de manutenção deste, se o caso;
            </p></li>
            <li><p>
                arcar com impostos e taxas aplicáveis ao Veículo utilizado, de forma a
                mantê-lo devidamente registrado e licenciado; e
            </p></li>
            <li><p>
                arcar com os custos e obrigações relacionados ao contrato de aluguel do
                Veículo que utilizará para a prestação dos Serviços de Delivery, se o Veículo
                for alugado.
            </p></li>
        </ol>
        <h3>7. SINISTROS E DANOS</h3>
        <p>
            7.1. O Entregador será o único responsável por eventuais danos que vier causar
            a terceiros ou em relação a prejuízos em que venha a incorrer decorrentes da
            execução dos Serviços de Delivery.
        </p>
        <p>
            7.2. O GPA não se responsabiliza pelas interações que possam ocorrer durante
            os Serviços de Delivery entre clientes do GPA e o Entregador, nem deste com
            terceiros.
        </p>
        <h3>8. TAXA DO ENTREGADOR E PAGAMENTO </h3>
        <p>
            8.1. A cada Solicitação aceita e concluída pelo Entregador, este terá direito ao
            recebimento da Taxa de Entregador, que será definida pela base de operações
            de cada cidade e poderá variar de acordo com a distância a ser percorrida para
            a conclusão do Serviços de Delivery.
        </p>
        <p>
            8.1.1. O cálculo da distância é realizado pela própria Plataforma, podendo ser
            acompanhado pelo Entregador. Dependendo da rota a ser utilizada pelo Entregador,
            poderá haver diferenças entre a distância efetivamente percorrida e a calculada
            pela Plataforma, de forma que a distância calculada pela Plataforma é
            que deverá ser considerada para fins da remuneração do Entregador.
        </p>
        <p>
            8.1.2. O Entregador reconhece que o valor da Taxa do Entregador é variável,
            podendo sofrer alterações em virtude das condições climáticas e/ou da demanda
            no momento da Solicitação.
        </p>
        <p>
            8.2. O pagamento do Preço é realizado pelo GPA, por meio da própria plataforma.
        </p>
        <h3>9. TRIBUTOS</h3>
        <p>
            9.1. Os tributos de qualquer natureza que incidam sobre as transações previstas
            neste Termo serão de exclusiva responsabilidade da parte a quem a lei atribui a
            condição de contribuinte, exceto nas hipóteses em que a lei atribua a terceiro a
            responsabilidade pela retenção e recolhimento.
        </p>
        <h3>10. ISENÇÃO DE RESPONSABILIDADE DO GPA</h3>
        <p>
            10.1. As responsabilidades do GPA se restringem a atuar como agente intermediador
            dos Serviços de Delivery.
        </p>
        <h3>11. DECLARAÇÕES E GARANTIAS</h3>
        <h4>Pelo Entregador</h4>
        <p>
            11.1. O Entregador declara (a) ter plenos poderes e autoridade para realizar os
            Serviços de Delivery e cumprir com as disposições do presente Termo, (b) estar
            devidamente constituído, validamente existente e idôneo sob as leis brasileiras
            e (c) que observará todas as leis vigentes enquanto atuar como um Entregador
            James.
        </p>
        <h4>Pelo GPA </h4>
        <p>
            11.2. O GPA não garante a disponibilidade ou o tempo de atividade da Plataforma,
            de forma que a Plataforma poderá ficar indisponível, limitada e/ou suspensa
            a qualquer momento e por qualquer motivo.
        </p>
        <h3>12. IMPLICAÇÕES</h3>
        <p>
            12.1. O descumprimento, parcial ou total, pelo Entregador, de qualquer das
            obrigações assumidas no presente Termo poderá ensejar: (i) a suspensão da
            conta, (ii) o cancelamento definitivo da conta; (iii) o ressarcimento por perdas
            e danos; e (iv) a adoção de providências legais que o GPA venha a julgar necessárias,
            conforme o caso concreto.
        </p>
        <h3>13. PRIVACIDADE</h3>
        <p>
            13.1. O Entregador declara estar de acordo com os termos e condições da Política
            de Privacidade disponibilizada no aplicativo "Entregadores James", estando
            o GPA autorizado a utilizar das informações fornecidas conforme disposto
            em referido instrumento.
        </p>
        <h3>14. CONFIDENCIALIDADE</h3>
        <p>
            14.1. No cumprimento do presente Termo, os Entregadores poderão ter acesso
            ou serem expostos, direta ou indiretamente, a informações consideradas como
            confidenciais, tais como: dados e informações pessoais de clientes, planos de
            marketing e negócio, vendas, informações financeiras, técnicas e operacionais
            do GPA.
        </p>
        <p>
            14.2. Os Entregadores se obrigam a manter a confidencialidade sobre as informações
            confidenciais a que tiveram acesso, por meio ou no âmbito deste Termo,
            sejam elas verbais, escritas, impressas ou eletrônicas, de natureza técnica, financeira
            ou comercial.
        </p>
        <p>
            14.3. O descumprimento das obrigações de confidencialidade pelo Entregador
            poderá acarretar a obrigação de ressarcimento de eventuais perdas e danos sofridos
            pelo GPA, por dolo ou culpa.
        </p>
        <h3>15. ALTERAÇÕES </h3>
        <p>
            15.1. O GPA poderá alterar o presente Termo, a qualquer tempo e a seu critério,
            disponibilizando a sua nova versão na Plataforma para visualização por todos
            os Entregadores.
        </p>
        <p>
            15.2. Na hipótese de alterações significativas deste Termo, o GPA se compromete
            a comunicar previamente os Entregadores, e enviar o “novo” Termo, por
            meio do aplicativo Entregadores James, para análise e aceite ou recusa pelo
            Entregador.
        </p>
        <p>
            15.3. Caso o Entregador não esteja de acordo com o Termo alterado, ficará inativo
            na plataforma para o recebimento de pedidos e prestação dos Serviços de
            Delivery. Contudo, permanecerá o acesso restrito ao “menu financeiro” da plataforma,
            por (30) trinta dias, para acompanhamento do histórico financeiro das
            entregadas realizadas. A continuidade da prestação dos Serviços de Delivery
            após a referida alteração deste Termo depende, portanto, do aceite do Entregador
            à sua nova versão.
        </p>
        <h3>16. DIREITOS DE PROPRIEDADE </h3>
        <p>
            16.1. Todos os materiais contidos na Plataforma, o que inclui, sem se limitar a,
            software, imagens, textos, gráficos, ilustrações, logotipos, patentes, marcas, áudios,
            vídeos, e direitos de propriedade intelectual relacionados, são de titularidade
            exclusiva do GPA. Ao Entregador não é permitido vender, licenciar, alugar,
            modificar, distribuir, copiar, reproduzir, transmitir, publicar, adaptar, editar
            ou criar trabalhos derivados de material ou conteúdo da Plataforma.
        </p>
        <p>
            16.2. Na hipótese de o Usuário ou Entregador encaminhar espontaneamente comentários
            ou ideias visando a melhora operacional da Plataforma, o GPA poderá
            utilizá-los em benefício da Plataforma, não sendo devida qualquer compensação
            financeira ao Usuário ou Entregador.
        </p>
        <h3>17. CESSÃO</h3>
        <p>
            17.1. O Entregador não poderá ceder, emprestar ou transferir os direitos e obrigações
            decorrentes dos Serviços de Delivery, bem como permitir o acesso de
            qualquer outra pessoa a sua Conta na Plataforma, sem aviso prévio e expresso
            consentimento e aprovação do GPA.
        </p>
        <h3>18. DISPOSIÇÕES FINAIS</h3>
        <p>
            18.1. O presente Termo constitui acordo integral entre o GPA e o Entregador,
            em relação à utilização da Plataforma.
        </p>
        <p>
            18.2. As comunicações decorrentes do presente Termo e relacionadas à utilização
            desta Plataforma, por parte do Entregador, deverão se dar por meio do telefone
            0800-027-1010.
        </p>
        <p>
            18.3. Qualquer tolerância em relação às obrigações deste Termo, ou mesmo o
            retardamento da exigibilidade de direitos, não importará em precedente, novação
            ou alteração, cujos termos continuarão exigíveis a qualquer tempo.
        </p>
        <p>
            18.4. A nulidade total ou parcial de qualquer item ou condição prevista neste
            Termo não afetará nem desobrigará o cumprimento das demais, que continuarão
            vigentes em todos os seus efeitos.
        </p>
        <h3> 19. RESOLUÇÃO DE CONTROVÉRSIAS </h3>
        <p>
            19.1. As partes concordam em conduzir, de boa-fé, uma tentativa de resolver
            qualquer dúvida e/ou controvérsia, disputa ou pleito decorrentes ou relacionados
            ao presente instrumento ou ao seu inadimplemento, por meio de uma negociação.
            Tal tentativa deverá ser feita por escrito.
        </p>
        <p>
            19.2. Em sendo necessário, as partes elegem, desde já, o foro Central da Comarca
            de São Paulo - SP, para dirimir eventuais conflitos decorrentes da utilização
            da Plataforma, renunciando a qualquer outro, por mais privilegiado que
            seja.
        </p>
        <p>
            O ENTREGADOR RECONHECE QUE O ENTREGADORES JAMES: (A) É
            UM APLICATIVO DE ACESSO A UMA PLATAFORMA QUE COMPLEMENTA
            A MODALIDADE DE ENTREGA DE PRODUTOS DO GRUPO
            PÃO DE AÇÚCAR (GPA) AOSA SEUS CLIENTES EM DOMÍCILIO, ADQUIRIDOS
            EM LOJAS FÍSICAS OU PELOS APLICATIVOS DO GRUPO;
            (B) NÃO ATUA COMO UMA EMPRESA DE ENTREGA OU DE LOGÍSTICA,
            E (C) NÃO OPERA COMO UM AGENTE EM RELAÇÃO À REALIZAÇÃO
            DE TAIS SERVIÇOS PELO ENTREGADOR.
        </p>
        <p>
            AO ACEITAR O PRESENTE INSTRUMENTO, O ENTREGADOR DECLARA
            EXPRESSAMENTE QUE ESTÁ CIENTE E CONCORDA COM OS
            TERMOS E CONDIÇÕES GERAIS DE USO DO ENTREGADORES JAMES
        </p>
    </article>
</div>